<template>
  <div>
    <header-section :title='"Điều khoản sử dụng"'></header-section>
    <content-term></content-term>
  </div>
</template>
<script>  
  import HeaderSection from "./components/Common/HeaderSection.vue";
  import ContentTerm from "./components/TermCondition/ContentTermCondition.vue";
  export default{
    components:{      
      HeaderSection,
      ContentTerm
    }
  };
</script>


// WEBPACK FOOTER //
// src/views/TermCondition.vue